import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import t from '@rcm/i18n-client';
import { useDispatch } from 'react-redux';
import { calculate } from '../../actions';

const CalculateButton = () => {
    const dispatch = useDispatch();

    const handleCalculateClick = useCallback(() => {
        dispatch(calculate());
    }, []);

    return <Button onClick={handleCalculateClick}>
        {t('Calculate')}
    </Button>
}

export default CalculateButton;

